function TheGame() {
    /*////////////////////////////////////////////////////////////////////////////////
//standard game logic
     */
    this.gameId = _ndok_app_id;
    this.backgroundcolor = 0xbfdfb6;
    this.positionGameItems = positionGameItems;
    this.initGame = initGame;
    this.resetGame = resetGame;
    this.stopGame = stopGame;
    this.startGame = startGame;
    this.cycleGame = cycleGame;
    var gameData = {};
    this.gameData = gameData;
    var sprites;

    var counter;




    var itemsPositionsObject = { r_9: { x: 781, y: 515, w: 45, h: 45, n: "r_9" }, r_8: { x: 737, y: 515, w: 46, h: 45, n: "r_8" }, r_7: { x: 694, y: 515, w: 46, h: 45, n: "r_7" }, r_6: { x: 651, y: 515, w: 46, h: 45, n: "r_6" }, r_5: { x: 606, y: 515, w: 46, h: 45, n: "r_5" }, r_4: { x: 562, y: 515, w: 46, h: 45, n: "r_4" }, r_3: { x: 519, y: 515, w: 46, h: 45, n: "r_3" }, r_2: { x: 474, y: 515, w: 46, h: 45, n: "r_2" }, r_1: { x: 432, y: 515, w: 43, h: 45, n: "r_1" }, l_9: { x: 369, y: 515, w: 45, h: 45, n: "l_9" }, l_8: { x: 325, y: 515, w: 44, h: 45, n: "l_8" }, l_7: { x: 283, y: 515, w: 43, h: 45, n: "l_7" }, l_6: { x: 239, y: 515, w: 44, h: 45, n: "l_6" }, l_5: { x: 194, y: 515, w: 45, h: 45, n: "l_5" }, l_4: { x: 151, y: 515, w: 44, h: 45, n: "l_4" }, l_3: { x: 107, y: 515, w: 44, h: 45, n: "l_3" }, l_2: { x: 62, y: 515, w: 44, h: 45, n: "l_2" }, l_1: { x: 19, y: 515, w: 46, h: 45, n: "l_1" }, r_green: { x: 431, y: 515, w: 396, h: 46, n: "r_green" }, l_green: { x: 19, y: 515, w: 396, h: 46, n: "l_green" }, formica_25: { x: 237, y: 261, w: 62, h: 39, n: "formica_25" }, formica_24: { x: 206, y: 300, w: 62, h: 39, n: "formica_24" }, formica_23: { x: 822, y: 270, w: 62, h: 39, n: "formica_23" }, formica_22: { x: 668, y: 333, w: 62, h: 39, n: "formica_22" }, formica_21: { x: 730, y: 348, w: 62, h: 39, n: "formica_21" }, formica_20: { x: 915, y: 328, w: 62, h: 39, n: "formica_20" }, formica_19: { x: 809, y: 221, w: 62, h: 39, n: "formica_19" }, formica_18: { x: 792, y: 309, w: 62, h: 39, n: "formica_18" }, formica_17: { x: 840, y: 348, w: 62, h: 39, n: "formica_17" }, formica_16: { x: 871, y: 241, w: 62, h: 39, n: "formica_16" }, formica_15: { x: 871, y: 199, w: 62, h: 39, n: "formica_15" }, formica_14: { x: 884, y: 289, w: 62, h: 39, n: "formica_14" }, formica_13: { x: 617, y: 358, w: 62, h: 39, n: "formica_13" }, formica_12: { x: 547, y: 339, w: 62, h: 39, n: "formica_12" }, formica_11: { x: 469, y: 339, w: 62, h: 39, n: "formica_11" }, formica_10: { x: 453, y: 73, w: 62, h: 39, n: "formica_10" }, formica_9: { x: 167, y: 339, w: 62, h: 39, n: "formica_9" }, formica_8: { x: 370, y: 289, w: 62, h: 39, n: "formica_8" }, formica_7: { x: 391, y: 339, w: 62, h: 39, n: "formica_7" }, formica_6: { x: 254, y: 339, w: 62, h: 39, n: "formica_6" }, formica_5: { x: 285, y: 232, w: 62, h: 39, n: "formica_5" }, formica_4: { x: 347, y: 241, w: 62, h: 39, n: "formica_4" }, formica_3: { x: 123, y: 314, w: 62, h: 39, n: "formica_3" }, formica_2: { x: 298, y: 280, w: 62, h: 39, n: "formica_2" }, formica_1: { x: 329, y: 319, w: 62, h: 39, n: "formica_1" }, stage: { x: 5, y: 0, w: 990, h: 599, n: "stage" } };
    var gameScene;



    /**
     * CORE GAME LOGIC
     */
    function initGame() {
        sprites = game.sprites;

        positionGameItems();

        makeScenes();
        makeCounter();
        document.addEventListener(GameEvents.ANSWER_OK, onAnswerOk, true);
        document.addEventListener(GameEvents.ANSWER_WRONG, onAnswerWrong, true);
        document.addEventListener(GameEvents.EVENT_START_GAME, onStartGame, true);

    }



    function resetGame() {
        resetItems();
        prepareData();
    }

    function startGame() {

        scenesContainer.removeChildren(0, scenesContainer.children.length);
        scenesContainer.addChild(gameData.scene.container);
        counter.setText(gameData.currentItem + "/" + gameData.numItems);
        cycleGame();
    }

    function onStartGame() {

    }

    function cycleGame() {

        if (gameData.currentItem < gameData.numItems) {
            renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        } else {

            setTimeout(end, 800);
        }

    }

    function end() {
        stopGame();
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_END_GAME));
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        loopSequence = [renderOnce];
    }

    function stopGame() {
        gameData.scene.clear();
    }

    function prepareData() {

        gameData.numItems = 2;
        gameData.currentItem = 0;
        gameData.scene = gameScene;
        gameData.scene.reset();
    }


    function makeScenes() {
        scenesContainer = new Container();
        scenesContainer.position.set(285, 0);
        game.gameContainer.addChild(scenesContainer);

        gameScene = new Scene('formiche', itemsPositionsObject);

    }

    function makeCounter() {
        counter = new ItemsCounter();
        //  game.gameContainer.addChild(counter.container);
    }


    function positionGameItems() {
        sprites.btn_gioca.x = 410;
        sprites.btn_gioca.y = 328;
        sprites.btn_gioca.alpha = 0;
    }

    function resetItems() {

    }

    /**
     * GAME LOGIC
     */
    function onAnswerOk(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.GREEN_LIGHT));
        gameData.currentItem++;
        //  counter.setText(gameData.currentItem + "/" + gameData.numItems);

    }

    function onAnswerWrong(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.RED_LIGHT));
    }
}

function Scene(sceneName, positions) {
    var name = sceneName;
    this.name = name;
    this.reset = reset;
    this.clear = clear;
    var animating;
    var currentState;
    this.setState = setState;

    //
    var tl = new TimelineMax();
    //
    var container = new Container();
    this.container = container;
    var buttonsContainer = new Container();
    var cursorIndex = 0;


    buttonsContainer.interactive = true;
    buttonsContainer.on('pointertap', onClick);

    renderer.view.addEventListener(GameEvents.EVENT_CYCLE_GAME, cycled);

    var sceneElements = {};

    var answer = { l: { n: 0, ok: false }, r: { n: 0, ok: false } };
    var formichePos = [];


    initScene();

    function initScene() {
        var i;
        var itemName;
        var spriteItem;
        var pos;

        var graphics;
        spriteItem = game.sprites.stage;
        pos = positions.stage;
        spriteItem.position.set(pos.x, pos.y);
        container.addChild(spriteItem);
        sceneElements.stage = spriteItem;

        for (i = 0; i < 18; i++) {
            spriteItem = new Sprite(game.sprites.formica.texture);
            container.addChild(spriteItem);
            sceneElements["formica_" + i] = spriteItem;
        }
        spriteItem = new Sprite(game.sprites.green.texture);
        pos = positions.l_green;
        spriteItem.position.set(pos.x - 1, pos.y - 1);
        container.addChild(spriteItem);
        sceneElements.l_green = spriteItem;

        spriteItem = new Sprite(game.sprites.green.texture);
        pos = positions.r_green;
        spriteItem.position.set(pos.x - 1, pos.y - 1);
        container.addChild(spriteItem);
        sceneElements.r_green = spriteItem;

        for (i = 0; i < 18; i++) {
            var side = i < 9 ? "l_" : "r_";
            var n = i % 9 + 1;

            pos = positions[side + n];
            graphics = new Graphics();
            graphics.beginFill(0xff0000);
            graphics.lineStyle(0, 0x000000, 0);
            graphics.drawRect(0, 0, pos.w, pos.h);
            graphics.endFill();

            graphics.position.set(pos.x, pos.y);
            graphics.blendMode = PIXI.BLEND_MODES.DARKEN;
            graphics.interactive = true;
            graphics.buttonMode = true;
            graphics.alpha = 0;
            buttonsContainer.addChild(graphics);
            sceneElements[side + n] = graphics;
        }
        for (i = 1; i < 26; i++) {
            formichePos.push(positions['formica_' + i]);
        }
        container.addChild(buttonsContainer);
    }


    function clear() {


    }

    function reset() {

        setState('newGame');
    }

    function resetFormiche() {
        sceneElements.l_green.visible = false;
        sceneElements.r_green.visible = false;
        answer.l.n = Math.floor(Math.random() * 8) + 1;
        answer.r.n = Math.floor(Math.random() * 8) + 1;
        answer.l.ok = false;
        answer.r.ok = false;
        var total = answer.l.n + answer.r.n;
        console.log(answer, total)
        formichePos = _.shuffle(formichePos);
        for (i = 0; i < 18; i++) {
            sceneElements["formica_" + i].visible = i < total;
            sceneElements["formica_" + i].anchor.x = i < answer.r.n ? 0.5 : 0.5;
            sceneElements["formica_" + i].scale.x = i < answer.r.n ? -1 : 1;

            sceneElements["formica_" + i].position.set(formichePos[i].x, formichePos[i].y);
            var side = i < 9 ? "l_" : "r_";
            var n = i % 9 + 1;
            sceneElements[side + n].alpha = 0;
        }
    }

    function cycled() {
        setState('ready');
    }

    function setState(state) {

        switch (state) {
            case 'newGame':
                resetFormiche();
                break;
            case 'ready':

                break;
            case 'animating':


                break;
        }
        currentState = state;

    }

    function onClick(e) {
        var i;
        var pos;
        if (currentState === "ready") {

            var numFormiche = -1;
            var sideFormiche = '';
            for (i = 1; i < 10; i++) {
                if (!answer.l.ok && sceneElements['l_' + i] === e.target) {
                    numFormiche = i;
                    sideFormiche = "l";
                }
                if (!answer.r.ok && sceneElements['r_' + i] === e.target) {
                    numFormiche = i;
                    sideFormiche = "r";
                }
            }

            if (numFormiche < 0) {
                return false;
            }


            var ok = numFormiche === answer[sideFormiche].n;


            if (ok) {
                answer[sideFormiche].ok = true;
                setState('animating');
                renderer.view.dispatchEvent(new Event('answerOk'));
                sceneElements[sideFormiche + '_green'].mask = sceneElements[sideFormiche + '_' + numFormiche];
                sceneElements[sideFormiche + '_green'].visible = true;
                tl.to(sceneElements[sideFormiche + '_' + numFormiche], 0.75, {
                    pixi: { alpha: 1 }
                }).addCallback(okComplete, "+=0.3");
                loopSequence = [renderAlways];

            } else {
                setState('animating');
                renderer.view.dispatchEvent(new Event('answerWrong'));
                tl.to(sceneElements[sideFormiche + '_' + numFormiche], 0.75, {
                    pixi: { alpha: 1 }
                }).addCallback(wrongComplete, "+=0.3");
                loopSequence = [renderAlways];
            }


        }

    }

    function okComplete() {

        if (answer.r.ok && answer.l.ok === false) {
            setState('ready');
        }

        theGame.cycleGame();
        loopSequence = [renderOnce];


    }

    function wrongComplete() {
        theGame.cycleGame();
        loopSequence = [renderOnce];
        setState('ready');
    }
}